import Navbar from "../../components/navbar/navbar";
import HeaderMain from "../../containers/headerMain/headerMain";

import Footer from "../../containers/Footer/Footer";

function Home() {
    return (
        <>
            <Navbar />
            <HeaderMain />
            <Footer />
        </>
    );
}

export default Home;
